<!--
 * @Author: yyl
 * @Date: 2025-06-25 16:24:11
 * @LastEditTime: 2025-06-25 16:33:47
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/SidebarItem/index.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <el-submenu
    v-if="item.children && item.children.length"
    :index="String(item.id)"
  >
    <template slot="title">{{ item.title }}</template>
    <slider-item
      v-for="(child, i) in item.children"
      :key="i"
      :item="child"
      @menu-click="$emit('menu-click', $event)"
    />
  </el-submenu>

  <el-menu-item
    v-else
    :index="String(item.id)"
    @click="() => $emit('menu-click', item)"
  >
    {{ item.title }}
  </el-menu-item>
</template>

<script>
export default {
  name: "SliderItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
